import { CSSProperties, useEffect, useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
import { useFitText } from '@flyyer/use-fit-text';
import clsx from 'clsx';
import { BarcodeViewerProps } from '.';

function BarcodeViewerSecondary({
  matrix = [0, 0, 0, 0, 0, 0],
  top = 0,
  left = 0,
  right,
  height = 0,
  width = 0,
  text = '',
  code = '',
  fontFamily = '"Primary"',
  fontWeight = 'bold',
  color = [255, 255, 255],
}: BarcodeViewerProps) {
  const [refresh, setRefresh] = useState(false);
  const isRight = right !== undefined ? true : false;
  const canvasRef = useRef<any>();

  const margin = height * 0.15;
  const heightFactor = 0.5;
  const borderRadius = margin / 4;
  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas && text) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      JsBarcode(canvas, text, {
        displayValue: false,
        margin: 0,
        width: 1,
      });
      JsBarcode(canvas, text, {
        displayValue: false,
        height: height * heightFactor,
        margin: 0,
        width: (width - 2 * margin) / canvas.width,
      });
    }
  }, [text, height, width, top, left, refresh]);

  const { ref, fontSize, isCalculating } = useFitText(
    {
      maxFontSize: 1000,
      resolution: 10,
    },
    [width, height, text, refresh],
  );
  const className = clsx({ 'flyyer-wait': isCalculating });
  const marginFactor = 0.4;

  useEffect(() => {
    const timer = setInterval(() => {
      clearInterval(timer);
      setRefresh(!refresh);
    }, 1000);
  }, []);

  return (
    <div
      style={{
        position: 'relative',
        transition: 'transform 500ms',
        transformOrigin: `${isRight ? 'right' : 'left'} top`,
        transform: `matrix(${matrix.join(', ')})`,
      }}
    >
      <div
        style={{
          position: 'absolute',
          transition: 'height 500ms, top 500ms, left 500ms, right 500ms',
          top,
          ...(() => (isRight ? { right } : { left }))(),
        }}
      >
        <div
          style={{
            position: 'relative',
            height,
            width,
            transition: 'width 500ms, height 500ms',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: ((1 - heightFactor) / 2) * height - marginFactor * margin,
              left: margin * (1 - marginFactor),
              height: height * heightFactor + 2 * marginFactor * margin,
              margin: 0,
              width: width - 2 * (1 - marginFactor) * margin,
              background: `rgba(255, 255, 255)`,
              borderRadius,
            }}
          />
          <div
            ref={ref}
            className={className}
            style={{
              position: 'absolute',
              display: 'flex',
              fontFamily,
              top: 0,
              left: 0,
              width,
              height: ((1 - heightFactor) / 2) * height,
              fontSize,
              letterSpacing: '0.3px',
              fontWeight,
              visibility: code ? 'visible' : 'hidden',
              justifyContent: 'center',
              color: `rgb(${color[0]},${color[1]},${color[2]})`,
            }}
          >
            {code || 'code'}
          </div>
          <canvas
            ref={canvasRef}
            style={{
              position: 'absolute',
              transition: 'width 500ms, height 500ms, top 500ms, left 500ms',
              top: ((1 - heightFactor) / 2) * height,
              left: margin,
            }}
          />
          <div
            ref={ref}
            className={className}
            style={{
              position: 'absolute',
              display: 'flex',
              fontFamily,
              bottom: 0,
              left: 0,
              width,
              height: ((1 - heightFactor) / 2) * height,
              fontSize,
              letterSpacing: '0.3px',
              fontWeight,
              visibility: text ? 'visible' : 'hidden',
              alignItems: 'end',
              justifyContent: 'center',
              color: `rgb(${color[0]},${color[1]},${color[2]})`,
            }}
          >
            {text || 'text'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default BarcodeViewerSecondary;
